// API configuration
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

// App configuration
export const APP_NAME = 'Fotbal Club';
export const APP_DESCRIPTION = 'Oficiální web fotbalového klubu';

// Feature flags
export const FEATURES = {
  ENABLE_REGISTRATION: process.env.REACT_APP_ENABLE_REGISTRATION !== 'false',
  ENABLE_NEWSLETTER: true,
  ENABLE_CONTACT_FORM: true,
};

// Default settings
export const DEFAULTS = {
  PAGE_SIZE: 10,
  DATE_FORMAT: 'dd. MM. yyyy',
  DATE_TIME_FORMAT: 'dd. MM. yyyy HH:mm',
};

// Local storage keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  USER_DATA: 'user_data',
  THEME_PREFERENCE: 'theme_preference',
};
